<script>
   /*************************************************************/
   /* AppPlots component for train tab                          */
   /* -----------------------------------                       */
   /* defines plot components, controls and parameters          */
   /*************************************************************/

   import { untrack } from 'svelte';
   import { getDefaults } from 'svelte-controls-basic';
   import { Container, Button } from 'svelte-controls-basic';

   // global plot router
   import PlotsRouter from '@mdatools-apps/shared/plots/PlotsRouter.svelte';

   // import plot components
   import PlotAcceptance from '../shared/PlotAcceptance.svelte';
   import PlotExtremes from '../shared/PlotExtremes.svelte';
   import PlotDataset from '../shared/PlotDataset.svelte';

   // import plot controls components
   import { CAT_COLORS } from '@mdatools-apps/shared/plots/Defaults.js';
   import { getPlotAcceptanceControls, getPlotExtremesControls } from '@mdatools-apps/shared/plots/Controls.svelte.js';

   let {
      nimca,
      calres,
      calsetp,
      markOutlier,
   } = $props();

   // the data and the results this component was mounted with. 'untrack' marks the capture as
   // deliberate: AppContainer wraps this component in a key block, so a new set of results arrives
   // as a new component and never as new props for this one
   const data = untrack(() => ({'cal': calsetp}));
   const res = untrack(() => ({'cal': calres}));

   // colors for acceptance plot
   const classColmap = {'regular' : CAT_COLORS.regular, 'extreme': CAT_COLORS.extreme, 'outlier': CAT_COLORS.outlier};

   // if limType or result objects changed make updates to acceptance plot fixed parameters
   $effect(() => {
      if (nimca.limType) {
         const r = res[params.acceptance.resID].outcomes;

         // this is needed for correct color grouping, we simply provide
         // colorby values manually, based on classification outcomes
         params.acceptance['colorByObj'] = {
            classColmap,
            labels: [`regular: ${r.rolsNum.regular}`, `extreme: ${r.rolsNum.extreme}`, `outliers: ${r.rolsNum.outlier}`],
            values: r.rols
         }
      }
   });


   // JSON with plot components (scope is needed for providing correct properties)
   const plots = $derived({
      acceptance: {label: 'Acceptance', scope: 'objects', component: PlotAcceptance, buttons: buttons},
      extremes: {label: 'Extremes', scope: 'stats', component: PlotExtremes},
      dataset: {label: 'Datasets', scope: 'objects', component: PlotDataset, buttons: buttons},
   })

   // JSON with plots controls (as Widget properties). a plain object: nothing here sets a
   // 'hidden' flag or touches a descriptor after it is made, so there is nothing for $state
   // to track - only 'params' below changes
   const controls = untrack(() => ({
      acceptance: getPlotAcceptanceControls(res),
      extremes: getPlotExtremesControls(['cal']),
      dataset: getPlotExtremesControls(['cal']),
   }))

   // JSON with currently selected plots parameters
   let params = $state({
      acceptance: getDefaults(controls.acceptance),
      extremes: getDefaults(controls.extremes),
      dataset: getDefaults(controls.dataset),
   });


   // combine main elements to be shared with all plots together
   const props = $derived({ res, model: nimca, data});

</script>

{#snippet buttons(sel)}
   <Container label="Selected">
      <Button onclick={() => markOutlier(sel)} text="remove" class="destructive" />
   </Container>
{/snippet}


<PlotsRouter {plots} {controls} {props} bind:params={params} />
